"use client";

import { cn } from "utils";
import type { PortfolioInsightItem } from "./types";

interface PortfolioInsightNumberedCardProps {
  index: number;
  item: PortfolioInsightItem;
  className?: string;
  "data-testid"?: string;
}

/** PC · Figma 88100:38279 — numbered accent3 border card */
export const PortfolioInsightNumberedCard: React.FC<
  PortfolioInsightNumberedCardProps
> = ({ index, item, className, "data-testid": testId }) => {
  return (
    <article
      className={cn(
        "flex flex-col gap-2 rounded-4 border border-border_accent3_transparent50 bg-background_solid_neutral_primary p-4",
        className,
      )}
      data-testid={testId ?? "portfolio-insight-card-view"}
      data-variant="numbered"
    >
      <div className="flex items-center gap-2">
        <span
          className="flex size-7 shrink-0 items-center justify-center rounded-[14px] border-[1.5px] border-content_accent3_primary body_bold_s text-content_accent3_primary"
          aria-hidden
        >
          {index}
        </span>
        <h3 className="title_l text-content_primary">{item.title}</h3>
      </div>
      <p className="body_m text-content_primary">{item.body}</p>
    </article>
  );
};
